const INFINITY = 9999999;

export const PLANS = {
  free: {
    name: "Free",
    price: 0,
    limits: {
      collaborators: 3,
      custom_domain: false,
      watermark: false,
      cms_posts: 50,
      storage: 2 * 1024 * 1024 * 1024,
      file_upload_size: 25 * 1024 * 1024,
    },
  },
  basic: {
    name: "Basic",
    price: 20,
    limits: {
      collaborators: 5,
      custom_domain: true,
      watermark: true,
      cms_posts: 2000,
      storage: 10 * 1024 * 1024 * 1024,
      file_upload_size: 200 * 1024 * 1024,
    },
  },
  premium: {
    name: "Premium",
    price: 79,
    limits: {
      collaborators: 15,
      custom_domain: true,
      watermark: true,
      cms_posts: 10000,
      storage: 40 * 1024 * 1024 * 1024,
      file_upload_size: 1024 * 1024 * 1024,
    },
  },
  enterprise: {
    name: "Enterprise",
    price: 199,
    limits: {
      collaborators: 50,
      custom_domain: true,
      watermark: true,
      cms_posts: 100000,
      storage: 200 * 1024 * 1024 * 1024,
      file_upload_size: 2048 * 1024 * 1024,
    },
  },
  "saaszilla-1": {
    name: "Saaszilla 1",
    price: 199,
    limits: {
      collaborators: 1,
      custom_domain: true,
      watermark: true,
      cms_posts: 100000,
      storage: 200 * 1024 * 1024 * 1024,
      file_upload_size: 2048 * 1024 * 1024,
    },
  },
  "saaszilla-2": {
    name: "Saaszilla 2",
    price: 199,
    limits: {
      collaborators: 3,
      custom_domain: true,
      watermark: true,
      cms_posts: 100000,
      storage: 200 * 1024 * 1024 * 1024,
      file_upload_size: 2048 * 1024 * 1024,
    },
  },
  "saaszilla-3": {
    name: "Saaszilla 3",
    price: 199,
    limits: {
      collaborators: 30,
      custom_domain: true,
      watermark: true,
      cms_posts: 100000,
      storage: 200 * 1024 * 1024 * 1024,
      file_upload_size: 2048 * 1024 * 1024,
    },
  },
  "saaszilla-4": {
    name: "Saaszilla 4",
    price: 199,
    limits: {
      collaborators: 150,
      custom_domain: true,
      watermark: true,
      cms_posts: 100000,
      storage: 200 * 1024 * 1024 * 1024,
      file_upload_size: 2048 * 1024 * 1024,
    },
  },
  "appsumo-1": {
    name: "AppSumo 1",
    price: 59,
    limits: {
      website: 1,
      leads: 2500,
      pageviews: 200000,
      subscribers: 2500,
      ai: 15000,
      collaborators: 1,
      custom_domain: true,
      cms_posts: 100000,
      storage: 200 * 1024 * 1024 * 1024,
      file_upload_size: 2048 * 1024 * 1024,
    },
  },
  "appsumo-2": {
    name: "AppSumo 2",
    price: 119,
    limits: {
      website: 3,
      leads: 10000,
      pageviews: 1000000,
      subscribers: 10000,
      ai: 30000,
      collaborators: 3,
      custom_domain: true,
      cms_posts: 100000,
      storage: 200 * 1024 * 1024 * 1024,
      file_upload_size: 2048 * 1024 * 1024,
    },
  },
  "appsumo-3": {
    name: "AppSumo 3",
    price: 299,
    limits: {
      website: 10,
      leads: 10000,
      pageviews: 1000000,
      subscribers: 25000,
      ai: 100000,
      collaborators: 10,
      custom_domain: true,
      cms_posts: 100000,
      storage: 200 * 1024 * 1024 * 1024,
      file_upload_size: 2048 * 1024 * 1024,
    },
  },
  "appsumo-4": {
    name: "AppSumo 4",
    price: 599,
    limits: {
      website: 50,
      leads: 10000,
      pageviews: 1000000,
      subscribers: 25000,
      ai: 250000,
      collaborators: 100,
      custom_domain: true,
      cms_posts: 100000,
      storage: 200 * 1024 * 1024 * 1024,
      file_upload_size: 2048 * 1024 * 1024,
      watermark: true,
    },
  },
  "appsumo-5": {
    name: "AppSumo 5",
    price: 999,
    limits: {
      website: 100,
      leads: 100000,
      pageviews: 1000000,
      subscribers: 200000,
      ai: 1000000,
      collaborators: 1000,
      custom_domain: true,
      cms_posts: 100000,
      storage: 200 * 1024 * 1024 * 1024,
      file_upload_size: 2048 * 1024 * 1024,
      watermark: true,
    },
  },
};
